import { ref } from 'vue'
import axios from 'axios'

export function getTimeActual(){
    var fecha = new Date(); 
    var hora = fecha.getHours();
    var actualTime = '';
   
    if(hora >= 0 && hora < 12){
        actualTime = "Buenos días";
    }
   
    if(hora >= 12 && hora < 18){
        actualTime = "Buenas tardes";
    }
   
    if(hora >= 18 && hora < 24){
        actualTime = "Buenas noches";
    }
    return {actualTime}
  }


  export function getDateChartsActual(){
    var months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    var d = new Date();
    var mesActual = months[d.getMonth()];
    var yearActual = d.getFullYear();
    var dateChartActual = yearActual + "-" + mesActual
    return {dateChartActual}
  }


/************ Funciones api Paises */
export async function getPaises(){
  let paises =  [
        "Afghanistan",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Antigua And Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas The",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brasil",
        "British Indian Ocean Territory",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cape Verde",
        "Cayman Islands",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands",
        "Colombia",
        "Comoros",
        "Cook Islands",
        "Costa Rica",
        "Cote D'Ivoire (Ivory Coast)",
        "Croatia (Hrvatska)",
        "Cuba",
        "Cyprus",
        "Czech Republic",
        "Democratic Republic Of The Congo",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "East Timor",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Ethiopia",
        "Falkland Islands",
        "Faroe Islands",
        "Fiji Islands",
        "Finland",
        "France",
        "French Guiana",
        "French Polynesia",
        "French Southern Territories",
        "Gabon",
        "Gambia The",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guernsey and Alderney",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Heard and McDonald Islands",
        "Honduras",
        "Hong Kong S.A.R.",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Korea North",
        "Korea South",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macau S.A.R.",
        "Macedonia",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Man (Isle of)",
        "Marshall Islands",
        "Martinique",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands Antilles",
        "Netherlands The",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "Northern Mariana Islands",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestinian Territory Occupied",
        "Panama",
        "Papua new Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Pitcairn Island",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Republic Of The Congo",
        "Reunion",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Helena",
        "Saint Kitts And Nevis",
        "Saint Lucia",
        "Saint Pierre and Miquelon",
        "Saint Vincent And The Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "Smaller Territories of the UK",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Georgia",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Suriname",
        "Svalbard And Jan Mayen Islands",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad And Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks And Caicos Islands",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "United States",
        "United States Minor Outlying Islands",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Vatican City State (Holy See)",
        "Venezuela",
        "Vietnam",
        "Virgin Islands (British)",
        "Virgin Islands (US)",
        "Wallis And Futuna Islands",
        "Western Sahara",
        "Yemen",
        "Yugoslavia",
        "Zambia",
        "Zimbabwe"
  ]
  return paises
}

  export async function getEstados(pais){
    let response = await axios.get(`/paises/estados/${pais}`)
    return response.data
  }


  export async function getCiudades(estado){
    let response = await axios.get(`/paises/ciudades/${estado}`)
    return response.data
  }
  /************** Fin funciones api Paises */



  /***** Tipos de documentos ***/

  export function tiposDocumentos(){
    let tipos_documentos = [
      {id: 1, tipo: 'pasaporte'},
      {id: 2, tipo: 'cedula'},
      {id: 3, tipo: 'cedula extranjera'},
      {id: 4, tipo: 'dni'},
      {id: 5, tipo: 'ruc'},
      {id: 6, tipo: 'carnet extranjeria'},
      {id: 7, tipo: 'ptp'},
      {id: 8, tipo: 'carnet refugiado'},
      {id: 9, tipo: 'rif'},
      {id: 10, tipo: 'otros'},
    ]
    return {tipos_documentos}
  }



  
  /***** Divisas Paises ***/

  export function divisaPais(){
    let divisas = [
      {
        id: 1, 
        pais: 'venezuela',
        divisas: [{id: 1, divisa: 'Bolivares', simbolo: 'Bs'}, {id: 2, divisa: 'Dolares', simbolo: '$'}],
      },
      {
        id: 2, 
        pais: 'peru',
        divisas:[{id: 1, divisa: 'Soles', simbolo: 'S/.'}, {id: 2, divisa: 'Dolares', simbolo: '$'}],
      },
      {
        id: 3, 
        pais: 'chile',
        divisas:[{id: 1, divisa: 'Pesos Chilenos', simbolo: '$'}, {id: 2, divisa: 'Dolares', simbolo: '$'}],
      },
      {
        id: 4, 
        pais: 'ecuador',
        divisas: [{id: 1, divisa: 'Dolares', simbolo: '$'}],
      },
      {
        id: 5, 
        pais: 'colombia',
        divisas: [{id: 1, divisa: 'Pesos Colombianos', simbolo: '$'}, {id: 2, divisa: 'Dolares', simbolo: '$'}],
      },
      {
        id: 6, 
        pais: 'argentina',
        divisas: [{id: 1, divisa: 'Pesos Argentinos', simbolo: '$'}, {id: 2, divisa: 'Dolares', simbolo: '$'}],
      },
      {
        id: 7, 
        pais: 'bolivia',
        divisas: [{id: 1, divisa: 'Bolivianos', simbolo: 'B$'}, {id: 2, divisa: 'Dolares', simbolo: '$'}],
      },
      {
        id: 8, 
        pais: 'brasil',
        divisas: [{id: 1, divisa: 'Reals', simbolo: 'R$'}, {id: 2, divisa: 'Dolares', simbolo: '$'}],
      },
      {
        id: 9, 
        pais: 'spain',
        divisas: [{id: 1, divisa: 'Euros', simbolo: '€'}, {id: 2, divisa: 'Dolares', simbolo: '$'}],
      },
      {
        id: 10, 
        pais: 'united states',
        divisas: [{id: 1, divisa: 'Dolares', simbolo: '$'}],
      },
    ]
    return divisas
  }


  export function dataDivisaByPais(pais){
    const divisas = divisaPais()
    let divisaFilter = divisas.filter(item => item.pais == pais.toLowerCase())[0]
    return divisaFilter
  }

  /***********Fin divisas********** */


  /********** Medios de pago */
 
  export function getMediosPago(){
    let metodos_pago = 
    [
      {id:1, status: 1, metodo: 'Efectivo'},
      {id:2, status: 1, metodo: 'Transferencia'},
      {id:3, status: 1, metodo: 'Deposito'},
      {id:4, status: 1, metodo: 'Agora'},
      {id:5, status: 1, metodo: 'Yape'},
      {id:6, status: 1, metodo: 'Plin'},
      {id:7, status: 0, metodo: 'Tunki'},
    ]
    return metodos_pago
  }

  /********** Fin Medios de pago */



  /**** Roles Sistema */

export function getRoles(){
  let roles = 
  [
    {id: 1, rol: "admin"},
    {id: 2, rol: "editor"},
  ]
  return roles
}

  /****** fin Foles */


  /******** Dias Data  */

  export function getDias() {
    let dias = 
    [
      {id: 1, dia: "Lunes"},
      {id: 2, dia: "Martes"},
      {id: 3, dia: "Miercoles"},
      {id: 4, dia: "Jueves"},
      {id: 5, dia: "Viernes"},
      {id: 6, dia: "Sabados"},
      {id: 7, dia: "Domingos"},
    ]
    return dias
  }

  export function getHorasDia() {
    let horas = 
    [
      {id: 1, hora: 1},
      {id: 2, hora: 2},
      {id: 3, hora: 3},
      {id: 4, hora: 4},
      {id: 5, hora: 5},
      {id: 6, hora: 6},
      {id: 7, hora: 7},
      {id: 8, hora: 8},
      {id: 9, hora: 9},
      {id: 10, hora: 10},
      {id: 11, hora: 11},
      {id: 12, hora: 12},
    ]
    return horas
  }


  /******** Fin Dias Data  */